import React from 'react'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

const actionButtonSx = {
  width: 36,
  height: 36,
  border: '1px solid #D8E0E8',
  color: '#5A6F87',
  backgroundColor: '#FFFFFF',
  boxShadow: '0 1px 2px rgba(39, 88, 141, 0.06)',
  '&:hover': {
    borderColor: '#5A6F87',
    backgroundColor: '#F3F7FB'
  }
}

const actionMenuPaperSx = {
  minWidth: 210,
  mt: 0.5,
  border: '1px solid #D8E0E8',
  borderRadius: '12px',
  boxShadow: '0 12px 32px rgba(39, 88, 141, 0.16)',
  '& .MuiList-root': {
    pt: 0.5,
    pb: 0
  }
}

const actionMenuItemSx = {
  minHeight: 56,
  px: 2,
  gap: 1.5,
  fontSize: 14,
  color: '#1A2733',
  '&:hover': {
    backgroundColor: '#F3F7FB'
  }
}

const secondaryActionMenuItemSx = {
  ...actionMenuItemSx,
  alignItems: 'center',
  pt: 1,
  pb: 1,
  position: 'relative',
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent'
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: -4,
    right: 0,
    bottom: 4,
    left: 0,
    backgroundColor: 'transparent',
    pointerEvents: 'none',
    zIndex: 0
  },
  '&:hover::before': {
    backgroundColor: '#F3F7FB'
  },
  '& .MuiListItemIcon-root, & .MuiListItemText-root': {
    position: 'relative',
    zIndex: 1
  }
}

function ActionMenuEntry({ action, secondary = false, onClose }) {
  if (!action) return null

  const handleClick = (event) => {
    onClose?.(event, 'itemClick')
    action.onClick?.(event)
  }

  return (
    <MenuItem
      sx={secondary ? secondaryActionMenuItemSx : actionMenuItemSx}
      onClick={handleClick}
      disabled={action.disabled}
    >
      {action.icon ? (
        <ListItemIcon
          sx={{
            minWidth: 28,
            color: action.iconColor || 'action.active',
            ...(secondary ? { mt: '-8px' } : {})
          }}
        >
          {action.icon}
        </ListItemIcon>
      ) : null}
      <ListItemText
        primary={action.label}
        primaryTypographyProps={{
          fontSize: 14,
          fontWeight: 400,
          ...(secondary ? { mt: '-8px' } : {})
        }}
      />
    </MenuItem>
  )
}

export default function RowActionsMenu({
  anchorEl,
  currentItem,
  onClose,
  onExited,
  primaryActions = [],
  secondaryActions = []
}) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl && currentItem)}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{
        transition: {
          onExited
        },
        paper: {
          sx: actionMenuPaperSx
        }
      }}
    >
      {primaryActions.map((action) => (
        <ActionMenuEntry
          key={action.key || action.label}
          action={action}
          onClose={onClose}
        />
      ))}

      {primaryActions.length > 0 && secondaryActions.length > 0 ? (
        <Divider
          sx={{
            borderColor: '#0f0e0e',
            borderBottomWidth: 1
          }}
        />
      ) : null}

      {secondaryActions.map((action) => (
        <ActionMenuEntry
          key={action.key || action.label}
          action={action}
          secondary
          onClose={onClose}
        />
      ))}
    </Menu>
  )
}

export function RowActionsTrigger({ label = 'Acciones', onClick }) {
  return (
    <IconButton aria-label={label} onClick={onClick} sx={actionButtonSx}>
      <MoreHorizIcon fontSize="small" />
    </IconButton>
  )
}
